export default __webpack_public_path__ + "static/media/50_mobile.42e0d1ef.jpg";